
// document.getElementById("customToggleBtn").addEventListener("click", function () {
//   document.querySelector(".navbar-toggler").click()
// })

//-------------------------header-sticky-js-start--------------

    // $(window).scroll(function(){

    //     if ($(this).scrollTop() > 90) {

    //         $('header').addClass('sticky-header');

    //     } else {

    //         $('header').removeClass('sticky-header');

    //     }

    // });

//------------------------header-sticky-js-end------------------



//--------------------------toggle-btn-js------------------------

    // $(".navbar-toggler").click(function(){

    //     $(this).toggleClass('navbar-closed');

    //     $("html").toggleClass("myClass");

    //   });




   

    // $(document).ready(function(){

    //  if ($(window).width() < 767) {

    //          $(".filter-head").click(function(){

    //             $(".filter-box").toggleClass("show");

    //             $("html").toggleClass("myClassone");

    //           });

    //     } 

    // });

//-----------------------toggle-btn-js------------------------





// ---------------------body-close-event-js-start---------------------

    // $(document).on('click', function(event) {

    //   if (!$(event.target).closest('.filter-box').length) {

    //     $('.filter-box').removeClass('show');

    //     $("html").removeClass("myClassone");

    //   }

    // });

// ---------------------body-close-event-js-end-----------------------



//----------------------active-class-js-start-----------------

    //  jQuery(function($) {

    //     var path = window.location.href; 

    //     $('header a.nav-link').each(function() {

    //     if (this.href === path) {

    //     $(this).addClass('active');

    //       }

    //     });

    // });

//----------------------active-class-js-end-------------------







//-----------------------owl-js-start--------------------------
$('.banner-slider').owlCarousel({
    loop:true,
    margin:0,
    nav:false,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})



$('.room-slider').owlCarousel({
    loop:true,
    margin:25,
    nav:true,
    dots:false,
    stagePadding:120,   // side me cut slides dikhane ke liye

    navText:[
        `<svg width="17" height="12" viewBox="0 0 17 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.17 5.94L16.69 6.01L16.71 4.88H2.42L6.42 0.88L5.53 0L0 5.51L0.88 6.39L5.53 11.07L6.42 10.19L2.17 5.94Z" fill="white"/></svg>`,
        `<svg width="17" height="12" viewBox="0 0 17 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.54 5.13L0.02 5.05L0 6.19H14.28L10.29 10.19L11.17 11.07L16.71 5.56L15.83 4.67L11.17 0L10.29 0.88L14.54 5.13Z" fill="white"/></svg>`
    ],

    responsive:{
        0:{
            items:1,
            stagePadding:40
        },
        768:{
            items:1.5,
            stagePadding:60
        },
        992:{
            items:2,
            stagePadding:60
        },
        1200:{
            items:2,
            stagePadding:150   // desktop pe side slides cut dikhenge
        }
    }
});


$('.tursted-slider').owlCarousel({
    loop:true,
    margin:15,
    nav:false,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        992:{
            items:2
        },
        1000:{
            items:2
        }
    }
})

$('.you-mightslider').owlCarousel({
    loop:true,
    margin:18,
    nav:true,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:5
        }
    }
})
//-----------------------owl-js-end---------------------------

//-----------------------owl carousel-index-number-js-satrt---------------------------


// $(document).ready(function(){

//     var owl = $('.post-slider');

//     // FIRST — EVENTS REGISTER
//     owl.on('initialized.owl.carousel', function(event){
//         $("#total").text(event.item.count);
//     });

//     owl.on('changed.owl.carousel', function(event){
//         let total = event.item.count;
//         let clones = event.relatedTarget._clones.length / 2;
//         let index = event.item.index - clones;

//         if(index < 0) index = total + index;

//         index = (index % total) + 1;

//         $("#current").text(index);
//     });

//     // THEN — INITIALIZE CAROUSEL
//     owl.owlCarousel({
//         loop:true,
//         margin:20,
//         nav:false,
//         dots: true, 
//         responsive: {
//             0: { items: 2 },
//             767: { items: 2 },
//             991: { items: 3 },
//             1000: { items: 4 }
//         }
//     });

// });

//-----------------------owl carousel-index-number-js-end---------------------------



//-----------------------video-section-js-start--------------------------

 

    // const video = document.getElementById("video");

    // const circlePlayButton = document.getElementById("circle-play-b");



    // function togglePlay() {

    //     if (video.paused || video.ended) {

    //         video.play();

    //     } else {

    //         video.pause();

    //     }

    // }



    // circlePlayButton.addEventListener("click", togglePlay);

    // video.addEventListener("playing", function () {

    //     circlePlayButton.style.opacity = 0;

    // });

    // video.addEventListener("pause", function () {

    //     circlePlayButton.style.opacity = 1;

    // });

    

//-----------------------video-section-js-end----------------------------



//-------------------------------counter-js-start-------------------------



    // $('.counter').each(function() {

    //     var $this = $(this),

    //         countTo = $this.attr('data-count');

        

    //     $({ countNum: $this.text()}).animate({

    //       countNum: countTo

    //     },

    //     {

    //       duration: 1000,

    //       easing:'linear',

    //       step: function() {

    //         $this.text(Math.floor(this.countNum));

    //       },

    //       complete: function() {

    //         $this.text(this.countNum);

    //         //alert('finished');

    //       }

    //     }); 

    //   });



//-------------------------------counter-js-end--------------------------




 
  function toggleDesc() {
    const header = document.getElementById('descToggle');
    const body = document.getElementById('descBody');
    header.classList.toggle('open');
    body.classList.toggle('show');
  }
 
  // Style swatch selection
  document.querySelectorAll('.style-item').forEach(item => {
    item.addEventListener('click', function() {
      document.querySelectorAll('.style-item').forEach(i => i.classList.remove('active'));
      this.classList.add('active');
    });
  }); 


 //-------------------------------counter-js-end--------------------------
    function toggleAccordion() {
      document.getElementById('descAccordion').classList.toggle('open');
    }
 //-------------------------------counter-js-end--------------------------


  $(function () {
      const MIN = 0, MAX = 5000;
      let minVal = 0, maxVal = 4000;
      let dragging = null, startX = 0, startVal = 0;
 
      function pct(v) {
        return ((v - MIN) / (MAX - MIN)) * 100;
      }
 
      function render() {
        const minP = pct(minVal), maxP = pct(maxVal);
        $('#thumbMin').css('left', minP + '%');
        $('#thumbMax').css('left', maxP + '%');
        $('#fill').css({ left: minP + '%', width: (maxP - minP) + '%' });
        $('#priceLabel').text('$' + minVal.toLocaleString() + ' – $' + maxVal.toLocaleString());
      }
 
      function startDrag(e, which) {
        dragging = which;
        startX = e.type === 'touchstart' ? e.originalEvent.touches[0].clientX : e.clientX;
        startVal = which === 'min' ? minVal : maxVal;
        $('#thumb' + (which === 'min' ? 'Min' : 'Max')).addClass('active');
        e.preventDefault();
      }
 
      function onMove(e) {
        if (!dragging) return;
        const cx = e.type === 'touchmove' ? e.originalEvent.touches[0].clientX : e.clientX;
        const trackW = $('#track').width();
        const delta = Math.round(((cx - startX) / trackW) * (MAX - MIN) / 100) * 100;
        let val = Math.min(MAX, Math.max(MIN, startVal + delta));
        if (dragging === 'min') {
          minVal = Math.min(val, maxVal - 100);
        } else {
          maxVal = Math.max(val, minVal + 100);
        }
        render();
      }
 
      function stopDrag() {
        $('.thumb').removeClass('active');
        dragging = null;
      }
 
      $('#thumbMin').on('mousedown touchstart', e => startDrag(e, 'min'));
      $('#thumbMax').on('mousedown touchstart', e => startDrag(e, 'max'));
      $(document).on('mousemove touchmove', onMove).on('mouseup touchend', stopDrag);
 
      render();
    });

    const radios = document.querySelectorAll('input[type="radio"][name="color"]');
    const label = document.getElementById('selected-label');
    const names = {
      slate: 'Slate blue selected',
      brown: 'Dark brown selected',
      black: 'Black selected',
      tan: 'Tan / gold selected'
    };

    radios.forEach(r => {
      r.addEventListener('change', () => {
        label.textContent = names[r.value] || '';
      });
    });





    // single-product-slider=========================================================



$(document).ready(function () {
	let $slider = $(".single-product-slider");

	$slider.owlCarousel({
		loop: true,
		items: 1,
		margin: 0,
		nav: false,
		navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
		stagePadding: 0,
		autoplay: false
	});

	let dotcount = 1;
	$slider.closest('.single-product-slider-box').find('.owl-dot').each(function () {
		$(this).addClass('dotnumber' + dotcount);
		$(this).attr('data-info', dotcount);
		dotcount++;
	});

	let slidecount = 1;
	$slider.find('.owl-item').not('.cloned').each(function () {
		$(this).addClass('slidenumber' + slidecount);
		slidecount++;
	});

	$slider.closest('.single-product-slider-box').find('.owl-dot').each(function () {
		let grab = $(this).data('info');
		let slidegrab = $slider.find('.slidenumber' + grab + ' img').attr('src');

		if (slidegrab) {
			$(this).css("background-image", "url(" + slidegrab + ")");
		}
	});

	let $dotsContainer = $slider.closest('.single-product-slider-box').find('.owl-dots');
	let amount = $dotsContainer.find('.owl-dot').length;
	let gotowidth = 100 / amount;
	$dotsContainer.find('.owl-dot').css("height", gotowidth + "%");

	// Check if arrows already exist to avoid duplication
	if ($dotsContainer.length && !$dotsContainer.parent().hasClass('custom-dot-wrapper')) {
		$dotsContainer.wrap('<div class="custom-dot-wrapper"></div>');
		$dotsContainer.parent().prepend('<button class="dot-arrow-up" style="margin-bottom:5px; cursor:pointer;"><i class="fa-solid fa-angle-up"></i></button>');
		$dotsContainer.parent().append('<button class="dot-arrow-down" style="margin-top:5px; cursor:pointer;"><i class="fa-solid fa-angle-down"></i></button>');
	}

	let currentIndex = 0;

	$dotsContainer.parent().find('.dot-arrow-up').click(function () {
		if (currentIndex > 0) {
			currentIndex--;
			$dotsContainer.find('.owl-dot').eq(currentIndex).trigger('click');
		}
	});

	$dotsContainer.parent().find('.dot-arrow-down').click(function () {
		if (currentIndex < amount - 1) {
			currentIndex++;
			$dotsContainer.find('.owl-dot').eq(currentIndex).trigger('click');
		}
	});

	$dotsContainer.on('click', '.owl-dot', function () {
		currentIndex = $(this).index();
	});
});



// single-product-slider-end=========================================================